import { render, staticRenderFns } from "./fb.vue?vue&type=template&id=0b2ed3e7&"
import script from "./fb.vue?vue&type=script&lang=js&"
export * from "./fb.vue?vue&type=script&lang=js&"
import style0 from "./fb.vue?vue&type=style&index=0&id=0b2ed3e7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports